var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M613.315 824.337C777.846 824.337 911.225 690.958 911.225 526.428C911.225 361.897 777.846 228.519 613.315 228.519C448.785 228.519 315.406 361.897 315.406 526.428C315.406 690.958 448.785 824.337 613.315 824.337Z",
    fill: "#CB9A50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M875.277 699L917.408 741.13",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M917.408 699L875.277 741.13",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M896.405 603.609C905.2 603.609 912.33 596.479 912.33 587.684C912.33 578.889 905.2 571.759 896.405 571.759C887.61 571.759 880.48 578.889 880.48 587.684C880.48 596.479 887.61 603.609 896.405 603.609Z",
    fill: "#4C241D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M196.294 707.882C205.089 707.882 212.219 700.752 212.219 691.957C212.219 683.162 205.089 676.032 196.294 676.032C187.499 676.032 180.369 683.162 180.369 691.957C180.369 700.752 187.499 707.882 196.294 707.882Z",
    fill: "#4C241D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M538.905 141.849C547.7 141.849 554.83 134.72 554.83 125.925C554.83 117.13 547.7 110 538.905 110C530.11 110 522.98 117.13 522.98 125.925C522.98 134.72 530.11 141.849 538.905 141.849Z",
    fill: "#4C241D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M524.4 913.636C656.024 913.636 762.727 806.933 762.727 675.309C762.727 543.684 656.024 436.981 524.4 436.981C392.775 436.981 286.072 543.684 286.072 675.309C286.072 806.933 392.775 913.636 524.4 913.636Z",
    fill: "#FFCE56",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M523.934 586.005L419.666 764.75H628.202L523.934 586.005Z",
    fill: "#FFEC95",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M337.749 600.907C465.26 600.907 568.628 497.539 568.628 370.028C568.628 242.516 465.26 139.148 337.749 139.148C210.237 139.148 106.869 242.516 106.869 370.028C106.869 497.539 210.237 600.907 337.749 600.907Z",
    fill: "#A9BA5A",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M338.229 253.645L222.369 369.505L338.229 485.364L454.088 369.505L338.229 253.645Z",
    fill: "#77A052",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M717.176 555.588C824.121 555.588 910.817 468.892 910.817 361.947C910.817 255.002 824.121 168.306 717.176 168.306C610.231 168.306 523.535 255.002 523.535 361.947C523.535 468.892 610.231 555.588 717.176 555.588Z",
    fill: "#F96E43",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M769.163 273.199H665.967L614.369 362.572L665.967 451.945H769.163L820.761 362.572L769.163 273.199Z",
    fill: "#FC8C29",
    stroke: "#4C241D",
    strokeWidth: 29.7909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.41c24f19aabf11f583bdd55a7ff28ce1.svg";
export { ForwardRef as ReactComponent };